import React, { useContext, useState } from "react";
import { resetOrder, useCounter } from "../../../context/CounterContext";
import { ProductsContext } from "../../../context/ProductContext";
import { Button, Form, Image, Input, message, Modal } from "antd";
import { MedicineBoxOutlined } from "@ant-design/icons";
import { GrSubtractCircle } from "react-icons/gr";
import { IoIosAddCircleOutline } from "react-icons/io";
import "./cart.scss";
import Blanck404 from "../../Blanck404";
import { doc, setDoc } from "firebase/firestore";
import { firestore } from "../../../config/firestore";
import { Context } from "../../../context/Appcontext";
import { OrderContext } from "../../../context/OrderContext";
import { Link } from "react-router-dom";

const Cart = () => {
  const { state, dispatch } = useCounter();
  const { products } = useContext(ProductsContext);
  const { userUid, isProcessing, setIsProcessing, customdate } =
    useContext(Context);
  const { userOrder } = useContext(OrderContext);

  console.log("userOrder", userOrder);
  const handleCounter = (operation, productId, e) => {
    e.preventDefault(); // Prevent default behavior
    dispatch({ type: operation, productId });
  };
  const [visible, setVisible] = useState(false);
  const [order, setOrder] = useState(false);
  const handlePreviewClick = () => {
    setVisible(true); // Show the image in a modal on click
  };

  // console.log("state.productOrder",state.productOrder);
  const handleOrder = () => {
    setOrder(true);
  };

  const [formValues, setFormValues] = useState({
    name: "",
    phone: "",
    address: "",
    id: "",
  });

  // Handle change in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value, // Update the specific input field
    }));
  };
  // console.log(state.productOrder);
  // Handle form submission
  const handleSubmit = async () => {
    if (
      formValues.address.length > 5 &&
      formValues.id.length > 5 &&
      formValues.phone.length > 5
    ) {
      const orderFinalize = {
        location: formValues,
        product_Order: state,
      };
      try {
        const id = Math.random().toString(36).slice(2);
        const orderDetail = {
          id: id,
          userUid: userUid,
          Date: customdate,
          location: formValues,
          order: state.productOrder,
          status: "inactive",
        };
        console.log(orderDetail.order);
        if (userUid) {
          setIsProcessing(true);
          await setDoc(doc(firestore, "UserOrder", id), orderDetail);
          message.success("Order is done successfully!");
          setFormValues("");
          console.log("Form submitted: ", orderFinalize);
          setOrder(false);
          resetOrder(dispatch);
        } else {
          message.info("Please you can Login!");
          navigator("/auth/login");
        }
      } catch (error) {
        message.error("Order is not done Please try again!");
      }
    } else {
      message.info("Please file box according to requirement!");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row text-Center">
        {state.productOrder && state.productOrder.length > 0 ? (
          state.productOrder.map((orderItem) => {
            const counter = orderItem.currentCount || 0;

            return products
              .filter((product) => product.id === orderItem.productId)
              .map((product, i) => (
                <div
                  className="col-xl-3 col-lg-4 col-md-5 col-sm-9 col-10 "
                  key={i}
                >
                  <div className="m-1 p-2 border rounded selected">
                    <div
                      className="imgbox   d-flex"
                      style={{
                        height: "auto",
                        width: "100%",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div className="w-50  " style={{ height: "100px" }}>
                        <Image
                          width={100}
                          height={100}
                          preview={false} // Disable default preview and hover effect (eye icon)
                          onClick={handlePreviewClick}
                          src={product.pickUrl}
                        />
                        <Modal
                          open={visible}
                          footer={null}
                          onCancel={() => setVisible(false)}
                        >
                          <Image
                            className="w-100 h-50"
                            src={product.pickUrl}
                            alt={product.name}
                            style={{ width: "100%", height: "50vh" }} // Full width in modal
                          />
                        </Modal>
                      </div>

                      <p
                        className="p-1 links"
                        style={{
                          fontSize: "13px",
                          wordSpacing: "2px",
                          cursor: "pointer",
                        }}
                      >
                        {product.productDetail.length < 100 ? (
                          <>{product.productDetail.slice(0, 100)}......</>
                        ) : (
                          product.productDetail
                        )}
                      </p>
                    </div>

                    <div className="itemQuantity">
                      <p className="fs-6 text-between p-1 m-0">
                        <span className="fw-bold fs-6 text-success">
                          {product.name}
                        </span>
                        <span>
                          {" "}
                          Quantity{" "}
                          {orderItem.currentCount < 10 ? (
                            <>0{orderItem.currentCount} </>
                          ) : (
                            orderItem.currentCount
                          )}{" "}
                        </span>{" "}
                      </p>

                      <div className="detail  text-Center">
                        <div
                          className="chart border rounded px-2 py-1 text-between "
                          style={{ color: "#D3D3D3" }}
                        >
                          <span
                            className="text-Center  "
                            onClick={(e) => handleCounter("add", product.id, e)}
                            style={{ cursor: "pointer" }}
                          >
                            <IoIosAddCircleOutline size={20} fontWeight={3} />
                          </span>

                          <span className="px-1 fw-bold  text-Center">
                            {counter > 0 ? (
                              counter <= 9 ? (
                                `0${counter}`
                              ) : (
                                counter
                              )
                            ) : (
                              <MedicineBoxOutlined className="boxicon " />
                            )}
                          </span>

                          <span
                            className="text-Center  "
                            onClick={(e) => handleCounter("sub", product.id, e)}
                            style={{ cursor: "pointer" }}
                          >
                            <GrSubtractCircle size={18} />
                          </span>
                        </div>
                      </div>

                      <p className="p-0 m-0 text-between">
                        <span className=""> Price {product.price}</span>
                        <span className="">
                          {" "}
                          Total {product.price * orderItem.currentCount}
                        </span>
                      </p>
                    </div>
                    {/* Display product details */}
                  </div>
                </div>
              ));
          })
        ) : (
          <div className="col text-Center flex-column m-md-4">
            <button className="btn border text-decoration-none " style={{backgroundColor:"#3F3D56"}}><Link  style={{color:"#CCCCCC",textDecoration:"none"}} to='/'>Go to For Order</Link></button>
            <br />
           <div className=" text-Center "> <Blanck404 /></div>
            <p className="text-center fs-2 " style={{color:"#CCCCCC"}}>You have not product in order.</p>
          </div>
        )}
      </div>

      <div className="row  text-Center">
        {state.productOrder && state.productOrder.length > 0 ? (
          <div className="col-8  buttonOrder rounded-pill text-Center " onClick={handleOrder}>
            <button className="btn  rounded-pill " >
              Order Now
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="row mt-4">
        <div className="col text-center fs-3 fw-medium">You Order History</div>
      </div>
      <div className="row">
      {userOrder.map((item, index) => (
        item ? 
    <div className="col-3 border" key={index}>
    <p>{item.Date}</p>
    <p>
      {item.order.map((product, productIndex) => (
        <span key={productIndex}>
          <span> {product.productId} {"=>"} {product.currentCount} </span><br />
        </span>
      ))}
    </p>
  </div>:""
))}

      </div>
      <div className="row border border-success text-Center">
        <div className="col d-flex justify-content-center align-items-center border  ">
          <Modal open={order} footer={null} onCancel={() => setOrder(false)}>
            <div className="w-75">
              <Form
                col={20}
                onFinish={handleSubmit} // Ant Design handles form submission here
              >
                <Form.Item>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Name Atleast 5 character"
                    value={formValues.name}
                    onChange={handleChange}
                  />
                </Form.Item>

                <Form.Item>
                  <Input
                    type="text"
                    name="phone"
                    placeholder="Phone Atleast 5 number ..."
                    value={formValues.phone}
                    onChange={handleChange}
                  />
                </Form.Item>

                <Form.Item>
                  <Input
                    type="text"
                    name="address"
                    placeholder="Address Atleast 5 number ..."
                    value={formValues.address}
                    onChange={handleChange}
                  />
                </Form.Item>

                <Form.Item>
                  <Input
                    type="text"
                    name="id"
                    placeholder="Id Atleast 5 number ..."
                    value={formValues.id}
                    onChange={handleChange}
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    loading={isProcessing}
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Cart;
